import React, {Suspense, useContext} from 'react';
import { lazy } from 'react';
import {Switch, Route, Redirect} from "react-router-dom";
import LoginContext from './LoginContextAPI';
import LoadingScreen from './LoadingScreen';


const LoginPage = lazy(() => import("./Login"));
const Header = lazy(() => import("./Header/index"));
const MovieTvShowCase = lazy(() => import("./MovieTvShowcase/index"));
const MovieTvItemsSlider = lazy(() => import("./MovieTvItemsSlider/index"));
const Footer = lazy(() => import("./Footer/index"));
const MoreAboutTheItem = lazy(() => import("./MoreAboutTheItem/index"));
const FooterNavigation = lazy(() => import("./FooterNavigation/index"));


function App() {
  const loginContextData = useContext(LoginContext);

  return (
    <React.Fragment>
      <Suspense fallback={<LoadingScreen/>}>
        <Header />
        <Switch>
          <Route path="/sign-in" exact>
            <LoginPage/>
          </Route>

          <Route path="/sign-up" exact>
              <LoginPage/>
          </Route>
    
    {
      (loginContextData.isUserLoggedIn) ? (
        <React.Fragment>

          <Route path = "/home" exact>
            <MovieTvShowCase category="disney" />
              <MovieTvItemsSlider  category = "mix"/>
          </Route>

          <Route path = "/" >
            <Redirect to="/home" />
          </Route>

          <Route path = "/tv" exact>
            <MovieTvShowCase category="tv"/>
            <MovieTvItemsSlider category="tv"/>
          </Route>

          <Route path="/movies" exact>
              <MovieTvShowCase category="movie" />
              <MovieTvItemsSlider category="movie" />
          </Route>
            
          <Route path="/disney" exact>
            <MovieTvShowCase category="disney" />
            <MovieTvItemsSlider category="disney" />
          </Route>

          <Route path="/about/:showType/:showid">
            <MoreAboutTheItem />
          </Route>

          <Route path="/premium">
            <Redirect to="/disney" />
          </Route>

          <Route path="/sports">
            <Redirect to="/home" />
          </Route>

          <Route path="/kids">
            <Redirect to="/disney" />
          </Route>

          <FooterNavigation />
        </React.Fragment>
      ) : undefined
    }

    {
      !loginContextData.isUserLoggedIn ? (
        <Route>
          <Redirect to = "/sign-in" />
        </Route>
      ) : undefined
    }
    
    </Switch>
    
    <Footer />
    </Suspense>
    </React.Fragment>
  )
}

export default App;
